var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.857 0h7.746l3.556 3.556v11.301c0 .631-.512 1.143-1.143 1.143H2.857a1.143 1.143 0 01-1.143-1.143V1.143C1.714.512 2.226 0 2.857 0z",
    fill: "url(#import-doc_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.603 2.984V0l3.556 3.556h-2.984a.571.571 0 01-.572-.572z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.335 8.71L7.91 6.285 5.486 8.71M7.91 6.856v5.143",
    stroke: "#fff",
    strokeWidth: 1.143
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "import-doc_svg__paint0_linear",
    x1: 7.937,
    y1: 0,
    x2: 7.937,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75839E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525C6F"
  })))));
}
export default __webpack_public_path__ + "static/import-doc.377542fd.svg";
export { SvgImportDoc as ReactComponent };